import { render, staticRenderFns } from "./SensorCard.vue?vue&type=template&id=5a845ea2"
import script from "./SensorCard.vue?vue&type=script&lang=js"
export * from "./SensorCard.vue?vue&type=script&lang=js"
import style0 from "./SensorCard.vue?vue&type=style&index=0&id=5a845ea2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports